import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Dropdown } from 'shared/ui'
import { NAME_INBOX } from 'entities/Inbox'
import { type Inbox } from 'entities/Inbox/model/Inbox'
import { useConversationMenuContext } from 'pages/conversations/ui/ConversationMenu/context'
import {
  actionTeamsFavorite,
  menuTeamsFavorite,
} from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/Dropdown/Actions/TeamsFavorite'
import {
  actionNewFolder,
  menuNewFolder,
} from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/Dropdown/Actions/NewFolder'
import {
  actionMoveTo,
  menuMoveTo,
} from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/Dropdown/Actions/MoveTo'
import {
  actionTeamsMute,
  menuTeamsMute,
} from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/Dropdown/Actions/TeamsMute'

type IDropdownSimpleInboxProps = {
  inbox: Inbox
}

export const DropdownSimpleInbox: FC<IDropdownSimpleInboxProps> = observer(({ inbox }) => {
  const store = useConversationMenuContext()
  const items = [menuTeamsFavorite(inbox)]
  const children = store.selectInboxesGroupViews
    .filter((item) => item.id !== NAME_INBOX.Create)
    .filter((item) =>
      item.type === 'inbox_group'
        ? !item.teamsIds.map((teamId) => teamId).includes(inbox.id)
        : false
    )
    .map((item) => item.dropdownData)

  if (!inbox.isUnifiedInbox) {
    items.push(menuNewFolder())

    if (children.length) {
      items.push(menuMoveTo(children))
    }
    items.push(menuTeamsMute(inbox))
  }

  return (
    <Dropdown
      ariaLabel={'DropdownSimpleInbox'}
      icon={'moreHorizontal'}
      placement={'bottom-end'}
      tooltipProps={{
        disableInteractive: true,
        label: 'Show actions',
        placement: 'top-end',
      }}
      items={items}
      onChange={(item, parent) => {
        actionTeamsFavorite({ inbox, item }, store)
        actionNewFolder({ inbox, item }, store)
        actionMoveTo({ inbox, item, parent }, store)
        actionTeamsMute({ inbox, item }, store)
      }}
      width={inbox.isUnifiedInbox ? 136 : 154}
    />
  )
})
